// This context makes it possible to enable/disable the default scanner
// and allows other views to use the scanner if required.
import React, { useContext, useEffect } from 'react';

export interface DefaultScannerContextInterface {
    enabled: boolean;
    changeEnabled: (enabled: boolean) => void;
}

export const DefaultScannerContext = React.createContext<DefaultScannerContextInterface>({
    enabled: false,
    changeEnabled: () => {},
});

export const useChangeDefaultScanner = (enabled?: boolean, resetAfterwards: boolean = true) => {
    const { enabled: oldEnabled, changeEnabled } = useContext<DefaultScannerContextInterface>(DefaultScannerContext);

    useEffect(() => {
        if (enabled !== undefined) {
            changeEnabled(enabled);
        }

        if (resetAfterwards) {
            return () => {
                // Reset enabled to what it was before
                console.trace('Resetting default scanner value', enabled);
                changeEnabled(oldEnabled);
            };
        }
    }, [enabled]);
};
